import { defineComponent as _defineComponent } from 'vue'
import CustomerDetailsCardEmpty from "@/components/customer/CustomerDetailsCardEmpty";
  import CustomerDetailsCardLots from "@/components/customer/CustomerDetailsCardLot.vue";
  import { useStore } from "vuex";
  import { onMounted, ref } from "vue";
  import { getUser } from "@/features/useUser";
  import router from "@/router";
  import { normalizeLots } from "@/helpers/customer/normalizer";
  import { DetailsLot } from "@/types/CustomerLotDetails";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerLotsView',
  setup(__props, { expose: __expose }) {
  __expose();

  const store = useStore();
  const customerId = getUser()._id;
  const showSpinner = ref(true);
  const lots = ref([] as DetailsLot[]);

  function fetchLots() {
    store
      .dispatch("eoi/getEoisCustomerLots", customerId)
      .then((response) => {
        lots.value = normalizeLots(response.data);
      })
      .finally(() => {
        showSpinner.value = false;
      });
  }
  function onLot(lot: DetailsLot) {
    if (lot.id) {
      router.push(`/customer/lots/${lot.id}/eoi/${lot.eoiId}`);
    }
  }
  onMounted(() => {
    setTimeout(() => {
      fetchLots();
    }, 600);
  });

const __returned__ = { store, customerId, showSpinner, lots, fetchLots, onLot, get CustomerDetailsCardEmpty() { return CustomerDetailsCardEmpty }, CustomerDetailsCardLots, get useStore() { return useStore }, onMounted, ref, get getUser() { return getUser }, get router() { return router }, get normalizeLots() { return normalizeLots }, get DetailsLot() { return DetailsLot } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})